<template>
    <button @click="toggleChangeTeams()" class="button is-info">
        <span class="icon is-small">
            <i class="fas fa-edit"></i>
        </span>
    </button>
    <div class="modal" :class="[showTab ? 'is-active' : '']">
        <div class="modal-background"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">Change Teams</p>
                <button @click="closeTab" class="delete" aria-label="close"></button>
            </header>
            <section class="modal-card-body">
                <p>If you wish to change the number of teams, please mention the new team numbers below and "Save
                    changes".</p>
                <p class="block"><b>NOTE:</b> You need to re-assign the deliveries to the new teams.
                </p>
                <div class="columns is-mobile">
                    <div class="column">
                        <b>Driving Teams</b>
                        <input v-model="newDrivingTeams" class="input" type="number" />
                    </div>
                    <div class="column">
                        <b>Walking Teams</b>
                        <input v-model="newWalkingTeams" class="input" type="number" />
                    </div>
                </div>
                <div v-if="validationErrors.length" class="block notification is-danger is-light">
                    <p>
                        <b>Please correct the following error(s):</b>
                    <ul>
                        <li v-for="validationError in validationErrors" :key="validationError">{{ validationError }}
                        </li>
                    </ul>
                    </p>
                </div>
                <div v-if="!!error" class="notification is-danger">
                    <p>{{ error }}</p>
                </div>
            </section>
            <footer class="modal-card-foot">
                <button @click="updateTeams" class="button is-success" :class="[isLoading ? 'is-loading' : '']">Save
                    changes</button>
                <button @click="closeTab" class="button">Cancel</button>
            </footer>
        </div>
    </div>
</template>

<script>
export default {
    props: ['fdID', 'drivingTeams', 'walkingTeams'],
    data() {
        return {
            newDrivingTeams: this.drivingTeams,
            newWalkingTeams: this.walkingTeams,
            showTab: false,
            isLoading: false,
            error: null,
            validationErrors: [],
        }
    },
    methods: {
        closeTab() {
            this.showTab = false;
        },
        toggleChangeTeams() {
            this.showTab = true;
        },
        async updateTeams() {
            this.isLoading = true;
            this.validateForm();
            if (this.isFormValid) {
                try {
                    await this.$store.dispatch('fd/updateTeams', {
                        fdID: this.fdID,
                        drivingTeams: this.newDrivingTeams,
                        walkingTeams: this.newWalkingTeams
                    });
                    this.showTab = false;
                } catch (error) {
                    this.error = error.message || "Something went wrong!";
                    console.log(error);
                }
            }
            this.isLoading = false;
        },
        validateForm() {
            this.isFormValid = false;
            this.validationErrors = [];
            if (!this.newDrivingTeams) {
                this.validationErrors.push("Please input Driving Teams.")
            }
            if (!this.newWalkingTeams) {
                this.validationErrors.push("Please input Walking Teams.")
            }
            if (!this.validationErrors.length) {
                this.isFormValid = true;
            }
        }
    }
}
</script>
